module.exports = __webpack_public_path__ + "img/batch_edit_user_tags_save.1bc3fe3f.png";